//TODO
export var USERS_LIST_ROUTES = {
    manager: {
        id: 'manager-page-id',
        route: 'manager',
    },
    client: {
        id: 'client-page-id',
        route: 'client',
    },
};
export var DESIGNING_ROUTES = {
    main: {
        id: 'main-page-id',
        route: 'main',
    },
    constructor: {
        id: 'constructor-page-id',
        route: 'constructor',
    },
    account: {
        id: 'account-page-id',
        route: 'account',
    },
    subscribes_constructor: {
        id: 'subscribes-constructor-page-id',
        route: 'subscribes-constructor',
    },
    accounts: {
        id: 'accounts-page-id',
        route: 'accounts',
    },
    news: {
        id: 'news-page-id',
        route: 'news',
    },
    reports: {
        id: 'reports-page-id',
        route: 'reports',
    },
    guidbooks: {
        id: 'guidbooks-layout-id',
        route: 'guidbooks',
    },
    users_list: {
        id: 'users-list-layout-id',
        route: 'users-list',
    },
};
